<app-table
  *ngIf='ready'
  [columns]='tableColumns'
  [dataSourceParams]='dataSourceParams'
  [dataSource]='dataSource'
  [emptyDataText]="emptyDataText"
  [selectable]='false'></app-table>
